var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.095,
    height: 35.733,
    viewBox: "0 0 121.095 35.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d,.e,.f,.g,.h,.i,.j,.k{fill-rule:evenodd;}.b{fill:#3d3d3d;}.c,.d,.k{fill:#fff;}.e{fill:url(#a);}.f{fill:url(#b);}.g{fill:url(#c);}.h{fill:url(#d);}.i{opacity:0.2;}.j{opacity:0.12;}.k{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.472,
    y1: 1.035,
    x2: 2.361,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.95,
    y1: 1.879,
    x2: 1.69,
    y2: 1.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.926,
    y1: 0.946,
    x2: 1.835,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.856,
    y1: 2.093,
    x2: 1.897,
    y2: 2.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M116.609,35.733H4.487A4.489,4.489,0,0,1,0,31.266V4.467A4.483,4.483,0,0,1,4.487,0H116.609A4.485,4.485,0,0,1,121.1,4.467v26.8A4.49,4.49,0,0,1,116.609,35.733Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M116.609.715a3.772,3.772,0,0,1,3.772,3.752v26.8a3.765,3.765,0,0,1-3.772,3.752H4.487A3.772,3.772,0,0,1,.715,31.266V4.467A3.765,3.765,0,0,1,4.487.715Zm0-.715H4.487A4.489,4.489,0,0,0,0,4.467v26.8a4.483,4.483,0,0,0,4.487,4.467H116.609a4.485,4.485,0,0,0,4.487-4.467V4.467A4.49,4.49,0,0,0,116.609,0Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1681.24,277.077a2.72,2.72,0,0,1-2.03-.84,2.861,2.861,0,0,1-.819-2.05,2.8,2.8,0,0,1,.819-2.047,2.711,2.711,0,0,1,2.027-.84,2.747,2.747,0,0,1,2.029.84,2.966,2.966,0,0,1,0,4.095A2.7,2.7,0,0,1,1681.24,277.077Zm-24.062,0a2.819,2.819,0,0,1-2.038-.829,2.887,2.887,0,0,1,2.038-4.946,2.841,2.841,0,0,1,1.139.236,2.3,2.3,0,0,1,.866.619l.053.065-.6.593-.062-.074a1.716,1.716,0,0,0-1.4-.6,1.937,1.937,0,0,0-1.4.57,2.166,2.166,0,0,0,0,2.967,2.042,2.042,0,0,0,2.831,0,1.54,1.54,0,0,0,.41-.929h-1.936v-.833h2.767l.011.076a3.042,3.042,0,0,1,.04.419,2.507,2.507,0,0,1-.691,1.849A2.7,2.7,0,0,1,1657.178,277.077Zm31.992-.118h-.853l-2.613-4.181.022.753v3.426h-.853V271.42h.973l.027.042,2.457,3.939-.022-.751v-3.23h.862Zm-14.342,0h-.864v-4.7h-1.5v-.833h3.861v.833h-1.5v4.7Zm-3.068,0h-.862V271.42h.862Zm-4.845,0h-.862v-4.7h-1.5v-.833h3.86v.833h-1.5Zm-2.907-.009H1660.7V271.42h3.306v.833h-2.442v1.519h2.2v.824h-2.2v1.519h2.442Zm15.835-1.285a1.907,1.907,0,0,0,1.4.579,1.859,1.859,0,0,0,1.4-.579,2.195,2.195,0,0,0,0-2.95,1.911,1.911,0,0,0-1.4-.579,1.851,1.851,0,0,0-1.395.579,2.2,2.2,0,0,0,0,2.95Z",
    transform: "translate(-1617.447 -265.256)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1670.88,687.219a3.8,3.8,0,1,0,3.812,3.8A3.741,3.741,0,0,0,1670.88,687.219Zm0,6.1a2.31,2.31,0,1,1,2.143-2.3A2.2,2.2,0,0,1,1670.88,693.315Zm-8.316-6.1a3.8,3.8,0,1,0,3.812,3.8A3.741,3.741,0,0,0,1662.564,687.219Zm0,6.1a2.309,2.309,0,1,1,2.143-2.3A2.2,2.2,0,0,1,1662.564,693.315Zm-9.9-4.934v1.608h3.86a3.39,3.39,0,0,1-.873,2.025,3.939,3.939,0,0,1-2.979,1.181,4.289,4.289,0,0,1,0-8.577,4.121,4.121,0,0,1,2.907,1.152l1.141-1.141a5.609,5.609,0,0,0-4.039-1.628,5.9,5.9,0,1,0,0,11.794,5.4,5.4,0,0,0,4.119-1.657,5.337,5.337,0,0,0,1.4-3.772,4.97,4.97,0,0,0-.089-1h-5.449S1652.668,688.38,1652.668,688.38Zm40.475,1.252a3.532,3.532,0,0,0-3.255-2.421,3.61,3.61,0,0,0-3.582,3.8,3.714,3.714,0,0,0,3.771,3.8,3.772,3.772,0,0,0,3.166-1.686l-1.29-.864a2.161,2.161,0,0,1-1.867,1.052,1.941,1.941,0,0,1-1.847-1.152l5.081-2.105S1693.144,689.632,1693.144,689.632Zm-5.182,1.27a2.086,2.086,0,0,1,1.985-2.214,1.465,1.465,0,0,1,1.41.8Zm-4.128,3.682h1.669V683.419h-1.669Zm-2.74-6.521h-.06a2.632,2.632,0,0,0-2-.853,3.8,3.8,0,0,0,0,7.594,2.625,2.625,0,0,0,2-.864h.06v.546c0,1.45-.775,2.232-2.025,2.232a2.106,2.106,0,0,1-1.916-1.35l-1.45.606a3.627,3.627,0,0,0,3.364,2.243c1.956,0,3.614-1.152,3.614-3.961v-6.819H1681.1v.626Zm-1.916,5.251a2.311,2.311,0,0,1,0-4.6,2.136,2.136,0,0,1,2.025,2.312A2.11,2.11,0,0,1,1679.179,693.315Zm21.778-9.9h-3.99v11.166h1.668v-4.228h2.323a3.474,3.474,0,1,0,0-6.937Zm.049,5.378h-2.373v-3.832h2.373a1.916,1.916,0,1,1,0,3.832Zm10.3-1.6a3.142,3.142,0,0,0-2.978,1.707l1.479.615a1.586,1.586,0,0,1,1.519-.824,1.611,1.611,0,0,1,1.758,1.439v.118a3.74,3.74,0,0,0-1.738-.427c-1.6,0-3.217.873-3.217,2.511a2.581,2.581,0,0,0,2.769,2.462,2.349,2.349,0,0,0,2.123-1.092h.06v.864h1.609v-4.277C1714.693,688.3,1713.214,687.2,1711.309,687.2Zm-.209,6.115c-.546,0-1.31-.267-1.31-.954,0-.864.953-1.192,1.767-1.192a2.9,2.9,0,0,1,1.519.376A2.008,2.008,0,0,1,1711.1,693.315Zm9.461-5.877-1.916,4.843h-.06l-1.985-4.843h-1.8l2.979,6.77-1.7,3.763h1.737l4.583-10.533Zm-15.019,7.147h1.669V683.419h-1.669Z",
    transform: "translate(-1610.016 -667.785)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M400.508,299.46a1.81,1.81,0,0,0-.408,1.261v19.753a1.722,1.722,0,0,0,.417,1.25l.069.06,11.068-11.067v-.247L400.577,299.4Z",
    transform: "translate(-391.187 -292.73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M921.991,638.141,918.3,634.45v-.258l3.691-3.691.08.049,4.366,2.482c1.25.7,1.25,1.867,0,2.58l-4.366,2.482Z",
    transform: "translate(-897.843 -616.453)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M433.308,805.772,429.537,802,418.4,813.137a1.462,1.462,0,0,0,1.856.06l13.052-7.425",
    transform: "translate(-409.079 -784.133)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M433.308,294.193l-13.052-7.414a1.447,1.447,0,0,0-1.856.06l11.136,11.125Z",
    transform: "translate(-409.079 -280.098)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M433.619,967.7l-12.963,7.365a1.471,1.471,0,0,1-1.787.009l-.069.069.069.06a1.474,1.474,0,0,0,1.787-.009l13.052-7.414Z",
    transform: "translate(-409.47 -946.142)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1087.958,803.161l-4.458,2.531.08.08,4.367-2.482a1.564,1.564,0,0,0,.933-1.29A1.606,1.606,0,0,1,1087.958,803.161Z",
    transform: "translate(-1059.362 -784.133)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M402.363,286.738l17.419,9.9a1.642,1.642,0,0,1,.933,1.161,1.564,1.564,0,0,0-.933-1.29l-17.419-9.9c-1.25-.715-2.263-.118-2.263,1.31v.129C400.1,286.618,401.114,286.032,402.363,286.738Z",
    transform: "translate(-391.187 -279.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google_play_icon.a760eb604fc450cb8f3dcc6ac945a0a8.svg";
export { ForwardRef as ReactComponent };